import { AlertCircle, CheckCircle2, Info, TriangleAlert } from 'lucide-react'
import { cn } from './cn'

export type AlertTone = 'info' | 'success' | 'warning' | 'error'

export interface AlertProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
	tone?: AlertTone
	title?: React.ReactNode
	/** Omit the default icon for this tone. */
	hideIcon?: boolean
}

const toneMap: Record<AlertTone, { className: string; icon: React.ReactNode }> = {
	info: { className: 'alert-refined-info', icon: <Info size={18} /> },
	success: { className: 'alert-refined-success', icon: <CheckCircle2 size={18} /> },
	warning: { className: 'alert-refined-warning', icon: <TriangleAlert size={18} /> },
	error: { className: 'alert-refined-error', icon: <AlertCircle size={18} /> },
}

export function Alert({ tone = 'info', title, hideIcon, className, children, ...rest }: AlertProps) {
	const { className: toneClass, icon } = toneMap[tone]
	// success/info are non-interrupting status updates; error/warning deserve
	// an immediate screen-reader interrupt.
	const role = tone === 'error' || tone === 'warning' ? 'alert' : 'status'
	return (
		<div role={role} className={cn(toneClass, className)} {...rest}>
			{!hideIcon && <span className="shrink-0 mt-0.5">{icon}</span>}
			<div className="flex-1 min-w-0">
				{title && <div className="font-medium leading-tight mb-0.5">{title}</div>}
				<div className="leading-snug">{children}</div>
			</div>
		</div>
	)
}
